import { lang } from './lang.js';
import { settings } from './settings.js';
import { patterns } from './patterns/patterns.js';
import { beads } from './beads.js';

export const utils = {};
export class HiddenCanvas {
    constructor (width, height) {
        this.canvas = document.createElement('canvas');
        this.canvas.id = 'temp-canvas-' + utils.canvasCounter.toString();
        utils.canvasCounter++;
        this.canvas.style.display = 'none';
        this.canvas.width = width;
        this.canvas.height = height;
        document.body.appendChild(this.canvas);
        this.ctx = this.canvas.getContext('2d');
    }

    remove () {
        document.getElementById(this.canvas.id).remove();
    }
}

utils.canvasCounter = 0;

utils.RGBToHSL = (r, g, b) => {
    r /= 255;
    g /= 255;
    b /= 255;

    let cmin = Math.min(r,g,b);
    let cmax = Math.max(r,g,b);
    let delta = cmax - cmin;
    let h = 0;
    let s = 0;
    let l = 0;

    if (delta == 0) h = 0;
    else if (cmax == r) h = ((g - b) / delta) % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;
    h = (h/360);

    l = (cmax + cmin) / 2;

    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    return [h,s,l];
};
utils.hexTorgb = hex => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    return [r, g, b];
};

utils.hexTohsl = hex => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    const r = parseInt(result[1], 16) / 255;
    const g = parseInt(result[2], 16) / 255;
    const b = parseInt(result[3], 16) / 255;

    const cmin = Math.min(r, g, b);
    const cmax = Math.max(r, g, b);
    const delta = cmax - cmin;

    let h = 0;
    let s = 0;
    let l = 0;

    if (delta === 0) h = 0;
    else if (cmax === r) h = ((g - b) / delta) % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;

    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    s *=100;
    l *=100;

    return [h, s, l];
};

utils.hslToHex = (h, s, l) => {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const fn = n => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0');
    };
    return `${fn(0)}${fn(8)}${fn(4)}`;
};

utils.colorToHex = color => { // returns hex string in form #ABC123
    let myRGB = Phaser.Display.Color.ColorToRGBA(color);
    return Phaser.Display.Color.RGBToString(myRGB.r, myRGB.g, myRGB.b);
};

utils.isHexLight = color => {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
};

utils.returnPoint = (x=game.input.activePointer.position.x, y=game.input.activePointer.position.y) => {
    return game.cameras.main.getWorldPoint(x, y);
};

utils.oldReturnPoint = (x, y, startScroll=false) => {

    const myAngle = game.cameras.main.rotation;

    let adjustX = 0;
    let adjustY = -game.scale.width/200;

    let p = [x - (game.scale.width/2) + adjustX, y - (game.scale.height/2) + adjustY];
    let r = [p[0] / game.cameras.main.zoom, p[1] / game.cameras.main.zoom];
    let dist = Math.sqrt((r[0] * r[0]) + (r[1] * r[1]));
    let theta = utils.myArcTan(r[0], r[1])

    let newTheta = settings.pattern.rotateCamera ?
        theta + myAngle - (Math.PI/2):
        theta + myAngle;

    let s = [-(dist * Math.cos(newTheta)), dist * Math.sin(newTheta)];

    let myScroll = {};

    if (startScroll) {
        myScroll.x = game.startScroll.x;
        myScroll.y = game.startScroll.y;
    } else {
        myScroll.x = game.cameras.main.scrollX;
        myScroll.y = game.cameras.main.scrollY;
    }

    let q = [
        s[0] + myScroll.x + (game.scale.width/2),
        s[1] + myScroll.y + (game.scale.height/2)
    ];

    return {
        x: q[0],
        y: q[1]
    };
};

utils.myArcTan = (x, y) => {

    const quotient = (x === 0 && y === 0) ? 1 : y / x; // prevent NaN output

    let theta = Math.atan(quotient);

    if (y >= 0 && x < 0) {
        theta = -1 * theta;
    }

    if (y >= 0 && x >= 0) {
        theta = Math.PI - theta;
    }

    if (y < 0 && x >= 0) {
        theta = Math.PI - theta;
    }

    if (y < 0 && x < 0) {
        theta = (2 * Math.PI) - theta;
    }

    return theta;
};

utils.safariDraw = (x, y, w, h, canv) => {
    let _x = x, _y = y, _w = w, _h = h;

    if (_x < 0) {
        _w += _x;
        _x = 0;
    }

    if (_y < 0) {
        _h += _y;
        _y = 0;
    }

    if (_x + _w > canv.width) {
        _w = canv.width - _x;
    }

    if (_y + _h > canv.height) {
        _h = canv.height - _y;
    }

    [_x, _y, _w, _h].forEach(obj => obj = Math.floor(obj));

    const shouldDraw = (_w > 0 && _h > 0 && _x < canv.width && _y < canv.height);

    if (shouldDraw) {
        return [_x, _y, _w, _h];
    } else {
        return [0, 0, 0, 0];
    }
};

utils.myNiceDate = num => {
    let result = '';

    const myDate = new Date(num);
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const myMonthName = months[myDate.getMonth()];

    result = myDate.getDate().toString() + ' ' + myMonthName + ' ' + myDate.getFullYear();

    return result;
};

utils.internationalDate = num => {
    const myDate = new Date(num);

    return myDate.toLocaleDateString(lang.currentLanguage.code, {
        dateStyle: 'medium'
    });
};

export const internationalDate = utils.internationalDate;

utils.myFont = (size, myColor='#000') => ({fontFamily: '"Vollkorn", Verdana, sans-serif', fontSize: size + 'px', color: myColor});
utils.smallFont = (size, myColor='#000') => ({fontFamily: '"Open Sans", Verdana, sans-serif', fontSize: size + 'px', color: myColor});


const hues = [
    {name: 'red', start: 0},
    {name: 'red-orange', start: 12},
    {name: 'orange', start: 18},
    {name: 'orange-yellow', start: 37},
    {name: 'yellow', start: 46},
    {name: 'lime', start: 66},
    {name: 'green', start: 88},
    {name: 'green-blue', start: 161},
    {name: 'cyan', start: 174},
    {name: 'blue', start: 184},
    {name: 'lavender', start: 254},
    {name: 'magenta', start: 290},
    {name: 'pink', start: 325},
    {name: 'red', start: 341}
];

const saturations = [
    {name: 'grey', start: 0},
    {name: 'faint', start: 5},
    {name: 'pastel', start: 15},
    {name: '', start: 40},
    {name: 'vibrant', start: 80},
];

const lightnesses = [
    {name: 'black', start: 0},
    {name: 'murky', start: 9},
    {name: 'dark', start: 20},
    {name: 'fairly dark', start: 30},
    {name: '', start: 40},
    {name: 'pale', start: 65},
    {name: 'very pale', start: 83},
    {name: 'off-white', start: 83},
    {name: 'white', start: 98},
];

[hues, saturations, lightnesses].forEach(obj => {
    obj.forEach(element => {
        if (element.name) {
            element.name = lang.get('auto color: ' + element.name, element.name);
        }
    });
});

utils.returnApproxColor = color => {
    if (color > 0xffffff) color -= 0xff000000;
    const _color = Phaser.Display.Color.ValueToColor(color);
    const myHSL = utils.RGBToHSL(_color.red, _color.green, _color.blue);
    const hue = myHSL[0] * 360;
    const sat = myHSL[1] * 100;
    const lum = myHSL[2] * 100;

    const returnName = (a, arr) => {
        let result = '';
        arr.forEach(element => {
            if (element.start <= a) result = element.name;
        });
        return result;
    };

    let hueName = returnName(hue, hues);
    let satName = returnName(sat, saturations);
    let lumName = returnName(lum, lightnesses);

    let result;

    ['black', 'white', 'grey'].forEach(element => {
        if (lumName == element) result = lumName;
    });

    if (result) return result;

    if (hueName == 'red') {
        if (lum < 30) {
            hueName = lang.get('auto color: maroon', 'maroon');
        } else if (lum > 65) {
            hueName = lang.get('auto color: pink', 'pink');;
        }
    }
    if (hueName == 'red-orange' || (hueName == 'orange' ) ) {
        if (lum < 35) {
            hueName = lang.get('auto color: brown', 'brown');;
        }
    }
    if (hueName == 'yellow') {
        if (lum < 30) {
            hueName = lang.get('auto color: olive', 'olive');;
        }
    }

    result = '';

    if (lang.currentLanguage.adjective == 'before') {
        if (lumName !== '') result += lumName + ' ';
        if (satName !== '') result += satName + ' ';
        result += hueName;
    } else {
        if (lumName !== '') result = lumName + ' ' + result;
        if (satName !== '') result = satName + ' ' + result;
        result = hueName + ' ' + result;
    }

    return result;
};

utils.convertFinishName = finish => {
    if (settings.library.shape === 'round') {
        if (finish === 'plastic') return 'matte';
        if (finish === 'cylinder_matte') {
            return 'matte';
        } else if (finish === 'cylinder_semigloss') {
            return 'semigloss';
        } else if (finish === 'cylinder_gloss') {
            return 'gloss';
        } else return finish;
    } else if (settings.library.shape === 'cylinder') {
        if (finish === 'plastic') return 'cylinder_matte';
        if (finish === 'matte') {
            return 'cylinder_matte';
        } else if (finish === 'semigloss') {
            return 'cylinder_semigloss';
        } else if (finish === 'gloss') {
            return 'cylinder_gloss';
        } else return finish;
    } else {
        return 'plastic';
    }
};

utils.getMaxMin = ({value, max, min}) => {
    if (value > max) return max;
    if (value < min) return min;
    return value
};

utils.finishes = [
    'plastic', 'matte', 'semigloss', 'gloss',
    'cylinder_matte', 'cylinder_semigloss', 'cylinder_gloss',
];

utils.getConvertedbeadDisplayHeight = () => +(settings.beadDisplayHeight * 0.6).toFixed(3);

// get row and column count for patterns that don't use columns, such as triangle
utils.getSizeBasedRowsAndColumns = ({rows, columns, size}) => {
    rows = size;
    columns = 0; // not used
    return [rows, columns];
};

utils.getBeadDisplayHeight = ({aspectRatio}) => {
    return Math.min(
        Math.max(
            Math.round(60 / aspectRatio),
            30
        ),
        60
    );
};

const padDate = int => `${int < 10 ? '0' : ''}${int}`;

utils.YYYYMMDD = date => {
    date = date || new Date();
    const YYYY = date.getFullYear();
    const MM = padDate(date.getMonth() + 1);
    const DD = padDate(date.getDate());
    return `${YYYY}-${MM}-${DD}`;
};

utils.myTruncate = (str, num) => {
    if (str.length <= num) return str;
    return str.slice(0, num) + '...';
};

utils.getTagColor = tag => {
    const alphabetArr = 'abcdefghijklmnopqrstuvwxyz'.split('');
    // '123 Fruit' -> ['f', 'r', 'u']
    const tagArr = tag.toLowerCase().split('').filter(e => alphabetArr.includes(e)).slice(0, 3);
    // make sure array is 3 items long; fill gaps with 'a'
    const _tagArr = new Array(3).fill('').map((e, i) => tagArr[i] || 'a');
    const numArr = _tagArr.map(letter => alphabetArr.indexOf(letter));
    const num = numArr[0] * 625 + numArr[1] * 25 + numArr[2];
    const col = (num * 360 / 15625).toFixed(1);
    return `hsl(${col} 80% 40%)`;
};

utils.processUserInputTagStr = str => str.split(',')
    .map(str => str.trim().toLowerCase())
    .filter(str => str.length);

utils.getSizeDescription = file => {
    const myPattern = patterns.arr.find(p => p.name === file.settings.patternName);

    if (myPattern.noColumns) {
        return file.settings.rows.toString() + ' ' + lang.get('rows');
    }

    const rows = file.settings.rows, columns = file.settings.columns;

    const [_rows, _columns] = myPattern.getDisplayRowsAndColumns ?
        myPattern.getDisplayRowsAndColumns({rows, columns}):
        [rows, columns];

    return `${_rows} x ${_columns}`;
};

utils.niceDate = str => {
    const x = new Date(str.replaceAll('-', '/'));
    return x.toLocaleDateString();
};

utils.getImg = item => {
    if (!item?.fillColor) return '';
    const rt = game.add.renderTexture(0, 0, 36, Math.floor(settings.beadDisplayHeight * 0.6)).setOrigin(0.5).myIgnore();

    const shift = item.finishName === 'plastic' ? 3 : 0;

    const myObject = {
        x: 18,
        y: 15 + shift,
        fillAlpha: 1,
        fillColor: item.fillColor,
        secondColor: item.secondColor,
        letterCode: null,
        finishName: item.finishName,
        inner: item.inner,
        shape: settings.library.shape,
        angle: 0,
        active: true,
        scale: 0.5,
        selected: false
    };

    beads.render(myObject, rt);

    const result = rt.canvas.toDataURL();
    rt.destroy();

    return result;
};